export default __webpack_public_path__ + "static/media/Panda-Sound-Light.d2624c70.webp";